import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-metrics';
import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/bff/client';
import { Alarm as AlarmIcon } from '@spotahome/ui-library';

import ButtonWithIcon from '@components/ButtonWithIcon';
import { addAlert } from '@components/AlertModal/mutations';
import withModalHandle from '@components/withModalHandle';
import AlertModalWrapper from '@components/AlertModal/index';

import { showSuccessToast } from '@alerts/components/AlertToast';

import { TOKEN_EXPIRED } from '@common/channels';
import SoyuzLocalStorage from '@utils/soyuzLocalStorage';

const LOCAL_STORAGE_KEY = 'openAlertModal';

const parseBudget = (budget='') => {
  const splitBudget = budget.split('-');

  return {
    minPrice: splitBudget[0],
    maxPrice: splitBudget[1]
  };
};

const getAlertFromFilters = (cityId, filters) => ({
  cityId,
  moveIn: filters['move-in'],
  moveOut: filters['move-out'],
  propertyTypes: filters['type[]'],
  ...parseBudget(filters.budget)
});

class AlertButton extends PureComponent {
  componentDidMount() {
    const mustOpenAlertModal = SoyuzLocalStorage.extractItem(LOCAL_STORAGE_KEY);
    if (mustOpenAlertModal && this.props.isUserLogged) {
      this.props.handleModalOpen();
    }
  }

  handleClick = () => {
    if (this.props.isUserLogged) {
      this.props.handleModalOpen();
    } else {
      SoyuzLocalStorage.setItem(LOCAL_STORAGE_KEY, true);
      Mediator.publish(TOKEN_EXPIRED);
    }
  };

  createAlert = async alertData => {
    Metrics.ga.sendEvent('Search', 'Alert Icon', 'createAlert');
    try {
      await addAlert(alertData);
      this.props.handleModalClose();
      showSuccessToast();
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <Fragment>
        <ButtonWithIcon
          className="filter-header__results-button filter-header__results-button--alerts ga-search-form-my-alerts"
          title={trans('search.filter_header.alerts')}
          handleOnClick={this.handleClick}
        >
          {hover => (
            <AlarmIcon size="normal" theme={hover ? 'light' : 'base'} />
          )}
        </ButtonWithIcon>
        <AlertModalWrapper
          alert={getAlertFromFilters(this.props.cityId, this.props.filters)}
          cities={this.props.allCities}
          onConfirm={this.createAlert}
          onClose={this.props.handleModalClose}
          isModalOpen={this.props.isModalOpen}
        />
      </Fragment>
    );
  }
}

AlertButton.propTypes = {
  cityId: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    'bathrooms[]': PropTypes.arrayOf(PropTypes.string),
    bed: PropTypes.string,
    budget: PropTypes.string,
    'features[]': PropTypes.arrayOf(PropTypes.string),
    'move-in': PropTypes.string,
    'move-out': PropTypes.string,
    poi: PropTypes.string,
    'topology[]': PropTypes.arrayOf(PropTypes.string),
    'type[]': PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  allCities: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      name: PropTypes.string,
      currencyIsoCode: PropTypes.string
    })
  }).isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isUserLogged: PropTypes.bool
};

AlertButton.defaultProps = {
  isUserLogged: false
};

export default withModalHandle()(AlertButton);
